export default {"src":"/_next/static/media/medium.fd8e5275.svg","height":160,"width":719,"blurWidth":0,"blurHeight":0};